
import React from "react";
import {
  AppBar,
  Box,
  Toolbar,
  IconButton,
  Avatar,
  Typography
} from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";

import logoIcon from "../assets/logo-icon.png";
export default function TopAppBar({ onSystemOpen, onFileOpen, onClearChat,userDetail }) {
  console.log(userDetail)
  return (
    <AppBar position="fixed" color="inherit" elevation={1}>
      <Toolbar>
        <IconButton onClick={onSystemOpen}>
          <MenuIcon />
        </IconButton>
            <Box display="flex" alignItems="center" gap={1}>
          <img src={logoIcon} alt="IntelliTutor" height={28} />
          
        </Box>
        <Typography sx={{ flexGrow: 1, fontWeight: 600 }}>
          IntelliTutor
        </Typography>

        {/* <IconButton onClick={onClearChat}>
          <EditIcon /><Typography sx={{ flexGrow: 1, fontWeight: 600 }}>
          New Chat
        </Typography>
        </IconButton> */}
        {/* <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        gap: 1,
        padding: '8px 12px',
        borderRadius: '8px',
        cursor: 'pointer',
        transition: 'background-color 0.2s ease',
        '&:hover': {
          backgroundColor: '#f0f0f0', // hover selection
        },
      }}
    >
      <EditIcon fontSize="medium" />
      <Typography variant="body" fontWeight={500}>
        New chat
      </Typography>
    </Box> */}

        {/* <IconButton onClick={onFileOpen}>
          <FolderIcon />
        </IconButton> */}

        <Avatar sx={{ width: 36, height: 36 }} src={userDetail.picture} />
      </Toolbar>
    </AppBar>
  );
}
